import { useEffect, useState } from "react";
import ChakraUIRenderer from "chakra-ui-markdown-renderer";
import { Image, VStack } from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import NavMenu from "../../components/Menu";

export default function RoutingAPIV4() {
  const [postContent, setPostContent] = useState("");

  useEffect(() => {
    import("../routing-api-v4/routing-api-v4.md").then((res) => {
      fetch(res.default)
        .then((response) => response.text())
        .then((response) => setPostContent(response))
        .catch((err) => console.log(err));
    });
  }, []);

  return (
    <VStack backgroundColor={"#e0e0e0"} h="100vh" overflow="auto">
      <NavMenu />
      {/* <Spacer/> */}
      <article className="article">
        <div className="container">
          <div className="post-wrapper">
            <ReactMarkdown
              components={ChakraUIRenderer()}
              children={postContent}
              remarkPlugins={[remarkGfm]}
              skipHtml
            />
          </div>
        </div>
      </article>
    </VStack>
  );
}
